import React from "react";
import { TabelaDeCotacao } from "./index";

export default function SuperTimeCotacoes({ tipoCotacoes, nomeJogo, type }) {
  return (
    <div class="container-cotacoes">
      <h1>Premiações!</h1>
      <h2>Quanto posso ganhar?</h2>
      <p>
        A premiação do <strong className="capitalize"> {nomeJogo} </strong> é
        baseada no time ou liga apostado e no valor da aposta. Caso a aposta
        seja feita nas ligas, o prêmio varia de acordo com a quantidade de
        clubes que cada uma oferece.
      </p>
      <p>
        <strong>Segue cotação baseado em R$: 1,00.</strong>
      </p>

      <TabelaDeCotacao nomeValor={tipoCotacoes.nomeValor} type={type} />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/newDesign/components/cotacoes/super-time.jsx